import { WorkspaceRole } from '../../../../../../api/workspaces/getWorkspaceMembers';
import { extractEffectiveOperationPermission } from '../extractEffectiveOperationPermission';
import { OperationPermissionConfig } from '../types';

export interface DeterminePermissionsParams {
  permissionConfig: OperationPermissionConfig;
  isBetaUser: boolean;
  isPro: boolean;
  workspaceMemberType: WorkspaceRole;
}

/***
 * Using permissions based upon if they are a beta user, if they are pro and their library membership type
 */
export function determinePermissions({
  permissionConfig,
  isBetaUser,
  isPro,
  workspaceMemberType,
}: DeterminePermissionsParams) {
  return Object.entries(permissionConfig).map(
    extractEffectiveOperationPermission({
      isBetaUser: isBetaUser,
      isPro: isPro,
      workspaceMemberType: workspaceMemberType,
    })
  );
}
